import axios from 'axios';
import { swalAlert } from './utils';

let api_url;
const host = window.location.hostname;
if (host === "sys8.animanet.eu" || host === "localhost") {
  api_url = "https://formavalidations.fortium.fr/api";
} else {


  api_url = `${window.location.origin}/api`;
}

// Création instance principale
const API = axios.create({
  baseURL: api_url,
  timeout: 100000,
});


// ✅ Option globale : gérer ou non les erreurs automatiquement
API.handleError = true;

API.getUrl = () => api_url;

API.getRequestHeaders = (route) => {
  const headers = {};
  /*
  const token = route.startsWith('/admin')
    ? localStorage.getItem('adminToken')
    : localStorage.getItem('token');
  */

  const token = localStorage.getItem('token')
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

// === Intercepteur de requêtes ===
API.interceptors.request.use(
  (config) => {
    config.headers = { ...config.headers, ...API.getRequestHeaders(config.url) };
    return config;
  },
  (error) => Promise.reject(error)
);

// === Intercepteur de réponses ===
API.interceptors.response.use(
  (response) => {
    // ✅ Réponses normales
    return response;
  },
  (error) => {
    const res = error.response;
    const status = res?.status ?? 0;

    // 🌐 Erreur réseau
    if (!res) {
      if (API.handleError) swalAlert('⚠️ Impossible de contacter le serveur.');
      // 🚫 On bloque tout, on ne résout rien
      return API.handleError ? new Promise(() => { }) : Promise.reject(error);
    }
    // 🔧 Si le composant veut gérer lui-même
    if (API.handleError === false) {
      API.handleError = true;
      return Promise.reject(error);
    }


    if (error.response?.data?.error?.message) {
      swalAlert(error.response?.data?.error?.message);

    } else {
      // 🚨 Sinon on gère ici (comportement par défaut)
      switch (status) {
        case 404:

          swalAlert('❌ Ressource introuvable (404).');
          break;
        case 500:
          swalAlert(`⚠️ Erreur interne du serveur.<br><small>${res.data?.message || 'Erreur inconnue.'}</small>`);
          break;
        default:

          let message = res.data?.error?.message || '';
          if (message === '') {
            message = `Erreur (${status}) : ${res.data?.message || error.message}`
          }
          swalAlert(message);
          break;
      }
    }

    // 🚫 Et on stoppe le flux : la promesse ne résout ni ne rejette
    // -> Le composant n’exécutera pas la suite
    return new Promise(() => { });
  }
);
export default API;
